import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getShiftAssignments = (params: any = {}) => {
  const query = new URLSearchParams();
  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      query.set(key, params[key]);
    }
  }
  const queryString = query.toString();
  return api.get(`${BASE_URL}/api/v1/roster-assignments${queryString ? `?${queryString}` : ""}`);
};

export const createShiftAssignment = (payload: any) => {
  return api.post(`${BASE_URL}/api/v1/roster-assignments`, camelToSnake(payload));
};

export const deleteShiftAssignment = (id: number) => {
  return api.delete(`${BASE_URL}/api/v1/roster-assignments/${id}`);
};
